import React from 'react';
import { IconSvg } from 'src/assets';
import { CardContainer, IconLabel, RegularText, Row } from 'src/components';
import { fontSizes, metrics } from 'src/themes/Metrics';

export const DateTimeCalendar = ({
  date,
  time,
  fontSize,
  fontWeight,
  iconColor = '#CACACA',
  lineColor = '#CACACA',

  color,
}: {
  lineColor?: string;
  date: string;
  time?: string;
  fontSize?: keyof typeof fontSizes | number;
  fontWeight?: 'normal' | 'bold' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';
  iconColor?: string;
  color?: string;
}) => {
  return (
    <IconLabel
      icon={<IconSvg.Calender fill={iconColor} />}
      label={
        <Row middle>
          <RegularText color={color} fontSize={fontSize} fontWeight={fontWeight}>
            {date}
          </RegularText>
          {time ? (
            <>
              <RegularText
                color={lineColor}
                style={{ paddingBottom: metrics.tiny }}
                fontSize={fontSize}
                fontWeight={fontWeight}>
                {'  '}|{'  '}
              </RegularText>
              <RegularText color={color} fontSize={fontSize} fontWeight={fontWeight}>
                {time}
              </RegularText>
            </>
          ) : (
            <CardContainer />
          )}
        </Row>
      }
    />
  );
};
